import { render } from "./AdministrationGroupsView.vue?vue&type=template&id=71a31d5f&scoped=true"
import script from "./AdministrationGroupsView.vue?vue&type=script&lang=js"
export * from "./AdministrationGroupsView.vue?vue&type=script&lang=js"

import "./AdministrationGroupsView.vue?vue&type=style&index=0&id=71a31d5f&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a31d5f"]])

export default __exports__